export const UserActionTypes = {
    SET_USERS: 'SET_USERS',
    SET_USER_COUNT: 'SET_USER_COUNT',
    SET_USER_ROWS_PER_PAGE:'SET_USER_ROWS_PER_PAGE',
    SET_DRIVING_LICENSE:'SET_DRIVING_LICENSE',
    SET_USER_DETAILS: 'SET_USER_DETAILS',
};
